import { Button, Select, Space } from 'antd';
import React, { Component } from 'react'
import { Card, Row, Col } from 'reactstrap';
import {
    PlusCircleOutlined
} from '@ant-design/icons';

const { Option, OptGroup } = Select;

class SelectWidgets extends Component {

    constructor(props) {
        super(props);
        this.state = {
            widgetValue: "Select",
            openToast: false,
            removeToast: false,
            widgetData : {},
            staticWidget : props.dashboardWidgets
        }
    }


    componentDidMount() {
    }

    onSelectWidgets = (value) => {
        if (value !== null && value !== "Select") {
            let wData = {
                widgetType : value,
            }
            this.setState({
                widgetValue : value,
                widgetData: wData
            })
        }
    }

    onDisplayDataWidget = () => {
        if (this.state.widgetValue !== "Select") {
            this.AddWidgets();
            this.hideToast();
        }
    }

    AddWidgets = () => {
        let wData = {
            widgetType : this.state.widgetValue,
        }
        this.setState({
            staticWidget: [...this.state.staticWidget, wData],
            widgetValue: "Select"
        }, () => {
            this.props._getWidgets(this.state.staticWidget)
        })
    }

    hideToast = () => {
        setTimeout(() => {
            this.setState({
                openToast: false,
                removeToast: false
            })
        }, 3000)
    }

    render() {
        return (
            <Card className='shadow-none'>
                <Row className='mt-2'>

                    <Col>
                        <label
                            className="form-control-label font12"
                        >
                            Select Widgets
                        </label> <br />

                        <Select value={this.state.widgetValue} className='select-theme-width' onChange={this.onSelectWidgets}>
                            <OptGroup label="Label">
                                <Select.Option value="Card">Card</Select.Option>
                            </OptGroup>
                            <OptGroup label="Charts">
                                <Select.Option value="Pie">Pie</Select.Option>
                                <Select.Option value="Column">Column</Select.Option>
                                <Select.Option value="Bar">Bar</Select.Option>
                                <Select.Option value="Doughnut">Doughnut</Select.Option>
                                <Select.Option value="Line">Line</Select.Option>
                                <Select.Option value="Spline">Spline</Select.Option>
                                <Select.Option value="Area">Area</Select.Option>
                            </OptGroup>
                            <OptGroup label="Table">
                                <Select.Option value="Table">Table</Select.Option>
                            </OptGroup>
                        </Select>
                    </Col>
                    <Col className='d-flex align-items-end ml-3'>
                        <Button type="primary" className=''
                            size="middle"
                            onClick={e => {
                                this.state.widgetValue !== "Select" &&
                                    this.setState({
                                        openToast: true
                                    }, () => {
                                        this.onDisplayDataWidget()
                                    });
                            }
                            }
                        > <Space><PlusCircleOutlined className='pr-1' /></Space> Add Widgets</Button>
                        {this.state.openToast && <span className='df-text-success ml-3'>Widget Added Successfully</span>}
                        {this.state.removeToast && <span className='df-text-danger ml-3'>Widget Removed Successfully</span>}

                    </Col>
                </Row>
            </Card>
        );
    }
}

export default SelectWidgets;